import { hasPermission } from './utils';
import { TokenScope } from 'types/authTypes';

export const getFirstAvailableRoute = (
    tokenScopeList: TokenScope[],
    orgId: number,
    isGuestPassIntegrated: boolean,
    isTokenValid: boolean
): string => {
    const permissions = {
        hasDashRead: hasPermission(tokenScopeList, orgId, 'o', 'dash:r'),
        hasVisitorsRead: hasPermission(tokenScopeList, orgId, 'o', 'visitors:r'),
        hasLocationRead: hasPermission(tokenScopeList, orgId, 'o', 'location:r'),
        hasUsersRead: hasPermission(tokenScopeList, orgId, 'o', 'user:r'),
        hasRolesRead: hasPermission(tokenScopeList, orgId, 'o', 'role:r'),
        hasKiosksRead: hasPermission(tokenScopeList, orgId, 'o', 'kiosk:r'),
        hasRedFlagConfRead: hasPermission(tokenScopeList, orgId, 'o', 'redflagconf:r'),
        hasInvitationRead: hasPermission(tokenScopeList, orgId, 'o', 'invitation:r'),
        hasWorkflow:
            hasPermission(tokenScopeList, orgId, 'o', 'signinconf:r') ||
            hasPermission(tokenScopeList, orgId, 'o', 'signoutconf:r'),
        hasFieldsRead: hasPermission(tokenScopeList, orgId, 'o', 'fields:r'),
        hasAgreementsRead: hasPermission(tokenScopeList, orgId, 'o', 'agreements:r'),
        hasEmailTemplatesRead: hasPermission(tokenScopeList, orgId, 'o', 'emailtemplates:r'),
        hasAccountRead: hasPermission(tokenScopeList, orgId, 'o', 'account:r'),
        hasIntegrationRead: hasPermission(tokenScopeList, orgId, 'o', 'integration:r'),
        hasRptVisitorRead: hasPermission(tokenScopeList, orgId, 'o', 'rptvisitor:r'),
        hasRptTrendRead: hasPermission(tokenScopeList, orgId, 'o', 'rpttrend:r'),
        hasRptRedFlagRead: hasPermission(tokenScopeList, orgId, 'o', 'rptredflag:r'),
        hasRptHostRead: hasPermission(tokenScopeList, orgId, 'o', 'rpthost:r'),
        hasRptActivityRead: hasPermission(tokenScopeList, orgId, 'o', 'rptactivity:r'),
        hasRptGuestPassRead:
            hasPermission(tokenScopeList, orgId, 'o', 'rptguestpass:r') &&
            isGuestPassIntegrated &&
            isTokenValid,
    };

    const routes = [
        permissions.hasDashRead && '/dashboard',
        permissions.hasVisitorsRead && '/visitors',
        permissions.hasLocationRead && '/locations',
        permissions.hasKiosksRead && '/kiosks',
        permissions.hasRedFlagConfRead && '/redFlag',
        permissions.hasRptVisitorRead && '/reports/visitorReport',
        permissions.hasRptTrendRead && '/reports/repeatVisitors',
        permissions.hasRptRedFlagRead && '/reports/redFlagReport',
        permissions.hasRptGuestPassRead && '/reports/guestPassReport',
        permissions.hasRptHostRead && '/reports/hostReport',
        permissions.hasRptActivityRead && '/reports/activityLog',
        permissions.hasUsersRead && '/configuration/users',
        permissions.hasRolesRead && '/configuration/userRoles',
        permissions.hasInvitationRead && '/configuration/invitations',
        permissions.hasWorkflow && '/configuration/workflow',
        permissions.hasFieldsRead && '/configuration/formFields',
        permissions.hasAgreementsRead && '/configuration/agreements',
        permissions.hasEmailTemplatesRead && '/configuration/emailtemplates',
        permissions.hasAccountRead && '/administration/account',
        permissions.hasIntegrationRead && '/administration/integration',
    ].filter(Boolean);

    return routes[0] || '/support';
};
